import React, { useState } from 'react';
import { notification } from 'components/ds';
import { useNavigate } from 'react-router-dom';
import PageContainer from 'modules/account/components/PageContainer/PageContainer';
import { handleApiError } from 'components/ErrorHandler';
import { useGetTemplate } from '../../../configs/SchemaConfig';
import { pageConfigs } from '../../../configs/pageConfigs';
import { PasswordForm } from '../../../components/PasswordForm/PasswordForm';
import { usePassword } from '../../../hooks/usePassword';
import { useOtpStorage } from '../../../hooks/useOtpStorage';
import { RouteEnum } from '../../../constantes/RouteEnum';
import TurnstileCaptcha from 'components/TurnstileCaptcha';

interface PasswordFormValues {
  newPassword: string;
  confirmPassword: string;
}

export const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const {data: pageConfig = {}} = useGetTemplate(pageConfigs.forgotPassword.template);
  const {recoveryPassword, isLoading} = usePassword();
  const {otpId, otpCode} = useOtpStorage()
  const [captchaToken, setCaptchaToken] = useState<string>('');
  const [captchaKey, setCaptchaKey] = useState(0);
  
  const handleVerify = (token: string) => {
    setCaptchaToken(token);
  }
  
  const handleResetPassword = async ({newPassword}: PasswordFormValues) => {
    if (!otpId || !otpCode) {
      notification.error({
        message: 'Erro na validação',
        description: 'Ocorreu um erro ao validar o código. Por favor, verifique o código inserido e tente novamente.'
      });
      
      return;
    }
    
    if (!captchaToken) {
      notification.error({
        message: 'Verificação necessária',
        description: 'Por favor, complete a verificação de segurança.'
      });
      
      return;
    }
    
    try {
      const success = await recoveryPassword({
        otpId,
        otpCode,
        newPassword,
        captchaToken
      });
      
      if (success) {
        navigate(RouteEnum.LOGIN_USERNAME);
      }
    } catch (error: any) {
      setCaptchaToken('');
      setCaptchaKey(prev => prev + 1);
      
      handleApiError(error, 'Não foi possível redefinir sua senha');
    }
  };
  
  return (
    <PageContainer
      title={pageConfig.title}
      navigateBack={pageConfig?.navigateBack?.()}
      disabled={isLoading || !captchaToken}
    >
      <PasswordForm
        isLoading={isLoading}
        buttonText="Redefinir senha"
        onSubmit={handleResetPassword}
        captchaComponent={<TurnstileCaptcha onVerify={handleVerify} key={captchaKey}/>}
        disableSubmit={!captchaToken}
      />
    </PageContainer>
  );
};
